import { HistoryDetails } from "app/pages/company/settings/HistoryDetails";
import { TransactionDateFilter } from "app/pages/component/TransactionDateFilter";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { Filter } from "../../jobs/component/Filter";
import { Checkbox } from "sr/helpers/ui-components/CheckBox";
import { TableRow } from "./transactions/TableRow";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getTransaction } from "sr/utils/api/wallet/getTransaction";
import convertToISOFormat from "sr/helpers/functions/convertToISOFormat";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { Pagination } from "app/pages/component/Pagination";
export const Transaction = () => {
const [userId, setUserId] = useState<string>('')
const [loader, setLoader] = useState(true)
const [page, setPage] = useState(1)
const [limit, setLimit] = useState(10)
    const [details, setDetails] = useState<string>()
const [totalPage, settotalPage] = useState<number>(1);
const [data, setData] = useState([])
    const [from, setFrom] = useState(null)
    const [to, setTo] = useState(null)
        const [dataAdded, setdataAdded] = useState()
        const [pagination, setPagination] = useState(null)
    const [status, setStatus] = useState(['credited', 'debited'])

    useEffect(()=> {
            const {user_id} = getUserDetails()
            setUserId(user_id)
    },[])
    const fetchTransaction = async ()=> {
        setLoader(true)
        const queryParams = new URLSearchParams()
        if (page) queryParams.append('page', page.toString());
        if (limit) queryParams.append('limit', limit.toString());   
        const filterarr = []
        if (status?.includes('credited')){
            filterarr?.push({"to":userId})   
        } 
        if (status?.includes('debited')){
            filterarr?.push({"from":userId})
        }

        if (from && to) queryParams?.append('createdAt>', convertToISOFormat(from))  
            if (from && to) queryParams?.append('createdAt<', convertToISOFormat(to))  
        const filter = {"$or":filterarr}
        queryParams.append('filter', JSON.stringify(filter))
                const res = await getTransaction(queryParams)
                if(res?.success===true) {
                    setData(res?.data)
                    settotalPage(Math.ceil(res?.pagination.total / limit));
                    setPagination(res?.pagination)
                    setLoader(false)
                }
                else {
                    setLoader(false)
                }
    }
    useEffect(()=>{
        if(userId){
            fetchTransaction()
        }
    },[userId, from, to, status, page])
  return (
    <ContentWithSpinner loader={loader} >
           {details ?
          <HistoryDetails setDetails={setDetails} setdataAdded ={setdataAdded} details={details}/>
          : 
       <>
       <div className="flex space-x-3 justify-normal mb-5 items-center">
       <TransactionDateFilter setFrom={setFrom} setTo={setTo}></TransactionDateFilter>
          <Filter name={<FormattedMessage id="MYJOB.FILTER.DROPDOWN.STATUS" defaultMessage='Status' /> } label={<FormattedMessage id="MYJOB.FILTER.DROPDOWN.STATUS" defaultMessage='Status' /> }>
         <Checkbox id='credited' name='credited' onChange={(e)=> CheckBoxHandle(e, status, setStatus)} checked={status?.includes('credited')} value='credited' label={'Credited'}></Checkbox>
         <Checkbox id='debited' name='debited' onChange={(e)=> CheckBoxHandle(e, status, setStatus)} checked={status?.includes('debited')} value='debited' label={'Debited'}></Checkbox>
   
      </Filter>
       </div>
       <div className="overflow-x-auto mt-4 rounded-[20px] border border-neutral-200">
       <table className="w-full text-left condidate-table">
           <thead className="bg-[#FAF9F8] border-collapse border-b border-neutral-200 capitalize">
               <tr>
               <th scope="col" className="px-6 py-4 text-base ">
     Transaction Type
   </th>  
               <th scope="col" className="px-6 py-4 text-base ">
    Activity
   </th>
   <th scope="col" className="px-6 py-4 text-base ">
    Amount
   </th>
   <th scope="col" className="px-6 py-4 text-base ">
     Date
   </th>
   
               </tr>
           </thead>
           <tbody>
               {data?.map((item)=> (
   
           <TableRow setDetails={setDetails} item={item}/>
     )) }
             
           </tbody>
       </table> 
       {totalPage>0 &&
       <div className="flex justify-between mx-5  my-3">
        <p>Total: {pagination?.total} Per Page: {limit}</p> 
       <p className="text-center">Page: {page} of {totalPage}</p>
       </div> 
   }
   {totalPage>0 &&
          <Pagination page={page} totalPage={totalPage} setPage={setPage} />
   }
   
       </div>
       </>
   }
      </ContentWithSpinner>
  );
};
